import { makeStyles } from "@material-ui/core/styles";
export default makeStyles((theme) => ({
  header: {
    background: "#E8E8E8",
    display: "flex",
    alignItems: "center",
    height: "49px",
    padding: "0px 0px 0 15px",
    "& h1": {
      padding: "0px 15px",
      fontSize: "22px",
      fontWeight: 600,
      lineHeight: "28.8px",
      color: "#2D4D95",
    },
  },
  gridHeader: {
    padding: "6px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& .HeaderDialog": {
      display: "flex",
      alignItems: "center",
      justifyContent: "right",
    },

  },
  DialogText: {
    color: '#4C4C4C !important',
    fontFamily: 'Lato',
    fontSize: '20px',
    fontStyle: 'normal',
    fontWeight: '600',
    lineHeight: '17px',
    letterSpacing: '0.2px',
    background: 'none',
    border: 'none',
  },
  gridActions: {
    textAlign: "right",
  },
  GridHeading: {
    color: '#2D4D95',
    textAlign: 'center',
    fontFamily: 'Lato',
    fontSize: '24px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: 'normal',
  },

  changeBtn: {
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    backgroundColor: "#454545",
    borderRadius: "6px",
    marginRight: "5px",
    padding: "8px 16px",
    textTransform: "capitalize",
    cursor: "pointer",
    color: "#ffffff",
    boxShadow:
      "0px 0px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(58, 58, 68, 0.12)",
    "&:hover": {
      color: "#ffffff",
      background: "#5e5e5e",
    },
  },
  profileNavigationIco: {
    maxWidth: "20px",
    padding: "2px",
  },

  Card: {
    borderRadius: "10px",
    // border: "1px solid #D9D9D9",
    backgroundColor: 'white',
    // display: "flex",
    padding: "15px",
    flexDirection: "column",
    alignItems: "center",
    gap: "29px",
    margin: "15px",
    position: "relative",
  

    "& .CardTop": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: 'center',
      width: "100%",
      padding: "10px 10px 10px 0px",
      marginBottom: '10px',
      borderBottom: '1px solid #D9D9D9',
    },
    "& .CardMain": {
      textAlign: "center",
    },
    "& .CardBanner": {
      position: "relative",
      width: "100%",
      height: "240px",
      maxHeight: "240px",
      minHeight: "240px",
    },
    "& .BannerImg": {
      borderRadius: "10px",
      height: "240px",
      maxHeight: "240px",
      minHeight: "240px",
    },
    "& img": {
      width: "100%",
      maxWidth: "100%",
      marginRight: "0",
    },
    "& .DetailLogo": {
      maxWidth: "24px",
      minWidth: "40px",
      maxHeight: "24px",
      position: "absolute",
      right: "0",
      top: "5px",
    },
    "& .CardHeading": {
      fontFamily: "Lato",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHight: "16px;",
      letterSpacing: "0.24px",
      marginBottom: "20px",
    },
    "& .CardBody": {
      color: "#424242",
      display: "-webkit-box",
      WebkitLineClamp: 2,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      maxWidth: "100%",

      textAlign: "center",
      fontFamily: "Lato",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "16px",
      letterSpacing: "0.14px",
      marginBottom: "20px",
    },
    "& .CardLogo": {
      width: "137px",
      minWidth: "137px",
      height: "35.773px",
      marginBottom: "20px",
    },
   
  },

  Container: {
    padding: "0px",
  },
  NoRecord: {
    height: "200px",
    width: "100%",
    background: "white",
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
  },
  PaiTextMain: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '2px',

    "& .PaiColorBox": {
      width: '20px',
      height: '20px',
      marginRight: '8px',
    }
  },
  BarChart: {
    width: '100% !important',
    height: '100% !important',
  },
  ListMain: {
    display: 'flex',
    alignItems: 'center',
    gap: '30px',
    alignSelf: 'baseline',
    paddingBottom: '10px',
    paddingTop: '10px',
    borderBottom: '1px solid #D9D9D9',
    width: '100%',


    "& .listImg": {
      width: '85px',
      height: '55px',
      borderRadius: '5px',
    }
  },
  BottomRightButton: {
    position: 'absolute',
    right: '20px',
    bottom: '20px',
  },
  profileNavigationIco: {
    maxWidth: '20px',
    padding: '2px',
  },
  profileDropper: {
    margin: '0px',
    padding: '0px',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    border: '1px solid #A3A3A3',
    borderRadius: '5px',
    "& h4": {
      margin: 0,
      padding: '10px',
      color: '#3C4549',
      fontSize: '15px',
      lineHeight: '16px',
      fontFamily: 'Lato',
      textTransform: 'capitalize',
      '@media (max-width: 550px)': {
        display: 'none',
      },
    },
    "& :hover": {
      backgroundColor: 'none !important',
    },
    "& svg": {
      color: '#41416E',
    }

  },

}));
